(function () {
    'use strict';

    angular.module("imApp").factory("productSettingsService", ['$ihttp', function ($ihttp) {
        let service = {
            listProductSettings: function (parms) {
                return $ihttp.post({
                    method: 673,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
